const TennisSerializer = {
    serializeGameContext(gameContext) {
        if (!gameContext) {
            return null;
        }
        const json = gameContext.toJSON ? gameContext.toJSON() : gameContext;
        [json.homeScore, json.visitorScore] = gameContext.score;
        return json;
    }
};

export default TennisSerializer;
